<template>
  <div class="tw-bg-white dark:tw-bg-gray-800 tw-rounded-xl tw-mx-4 tw-my-2 tw-overflow-hidden tw-shadow-sm">
    <div v-if="title || $slots.header || $slots.actions" class="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3 tw-pb-1">
      <slot name="header">
        <span class="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-nc-medium">{{ title }}</span>
      </slot>
      <slot name="actions" />
    </div>
    <div :class="padded ? 'tw-p-4' : ''">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'NcCard',
  props: {
    title: { type: String, default: '' },
    padded: { type: Boolean, default: false },
  },
};
</script>
